import { render } from "./appEduTeamLesson.vue?vue&type=template&id=160543fc&scoped=true"
import script from "./appEduTeamLesson.vue?vue&type=script&lang=js"
export * from "./appEduTeamLesson.vue?vue&type=script&lang=js"

import "./appEduTeamLesson.vue?vue&type=style&index=0&id=160543fc&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160543fc"]])

export default __exports__